import { Seeder } from '@mikro-orm/seeder';
import type { EntityManager } from '@mikro-orm/mysql';
import { ProgramTypesSeeder } from './ProgramTypesSeeder';
import { ProgramsSeeder } from './ProgramsSeeder';
import { CategoriesSeeder } from './CategoriesSeeder';

export class DatabaseSeeder extends Seeder {
  async run(em: EntityManager): Promise<void> {
    await this.call(em, [CategoriesSeeder, ProgramsSeeder, ProgramTypesSeeder]);
  }
}
